import { render } from "./SourceInfoViewCard.vue?vue&type=template&id=d20beb6c"
import script from "./SourceInfoViewCard.vue?vue&type=script&lang=js"
export * from "./SourceInfoViewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__